import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=492300ca&scoped=true"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"
import style0 from "./PushNotification.vue?vue&type=style&index=0&id=492300ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492300ca",
  null
  
)

export default component.exports